import React, { useEffect, useState } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

const QrScanner = () => {
    const [qrData, setQrData] = useState(''); // State to hold scanned QR data
    const scannerId = "qr-reader"; // Use a more descriptive ID for the scanner div

    useEffect(() => {
        const html5QrCodeScanner = new Html5QrcodeScanner(
            scannerId, // Correct ID for the scanner div
            {
                fps: 10, // Frames per second
                qrbox: { width: 250, height: 250 }, // QR code scanning area
            },
            false
        );

        const handleSuccess = (decodedText) => {
            setQrData(decodedText); // Update state with scanned data
            console.log(`QR Code Scanned: ${decodedText}`);
        };

        const handleError = (error) => {
            console.error(`QR Code Error: ${error}`);
        };

        // Start scanning
        html5QrCodeScanner.render(handleSuccess, handleError);

        // Cleanup on unmount
        return () => {
            html5QrCodeScanner.clear().catch((error) =>
                console.error("Failed to clear QR scanner.", error)
            );
        };
    }, []); // Ensure this only runs once

    return (
        <div style={{ textAlign: 'center' }}>
            <h1>Scan QR Code</h1>
            {/* Scanner Div with corrected ID */}
            <div id={scannerId} style={{ margin: '0 auto', width: '300px' }}></div>
            
            {/* Display scanned QR data below the camera */}
            {qrData && (
                <div style={{ marginTop: '20px' }}>
                    <h3>Scanned QR Data:</h3>
                    <p style={{ color: 'green', fontWeight: 'bold' }}>{qrData}</p>
                </div>
            )}
        </div>
    );
};

export default QrScanner;
